// extracted by mini-css-extract-plugin
export default {"layout":"b656240a0c _0a1c94856a ec5f25f763","h_slide":"cc138b5e1a","category":"_5efc9064ee a7e31e1c1f cc4b30af08"};